import * as a from 'actions/livefeed'
import defaultEditorState from 'components/pages/livefeed/defaultstate';
import update from 'immutability-helper';

export default (state, action) => {
    switch (action.type) {
        //Merge data
        case a.MERGE_SLIDES_DATA: {
            return update(defaultEditorState, {
                $merge: action.data
            })
        }
        case a.MERGE_LAYOUT: {
            return update(state, {
                livefeedSlides: { [action.slideCurrentIndex]: { $merge: action.payload } }
            })
        }
        // -------------------------- livefeed state update
        case a.SET_LIVEFEED_NAME: {
            return update(state, {
                livefeedName: { $set: action.livefeedName }
            })
        }
        case a.UPDATE_COLOR_PICKER_POS: {
            return {
                ...state,
                colorPickerPos: action.pos
            }
        }
        case a.SET_EDITOR_VIEW: {
            return update(state, {
                editorView: { $set: action.boolean }
            })
        }
        case a.DEFAULT_STATE: {
            return defaultEditorState
        }
        // ------------------------------------Livefeed and Toolbar editor state update
        // Font
        case a.SET_FONT_FAMILY: {
            return update(state, {
                livefeedSlides: { [action.slideCurrentIndex]: { fontFamily: { $set: action.font } } }
            })
        }
        // Logo
        case a.SET_LOGO: {
            return update(state, {
                livefeedSlides: { [action.payload.slideCurrentIndex]: { logoState: { $set: action.payload } } }
            })
        }
        case a.REMOVE_LOGO: {
            return update(state, {
                livefeedSlides: { [action.slideCurrentIndex]: { logoState: { $set: defaultEditorState.livefeedSlides[0].logoState } } }
            })
        }
        case a.REMOVE_LOGO_PLACEHOLDER: {
            let hideLogoPlaceholder = update(defaultEditorState.livefeedSlides[0].logoState, {
                show: { $set: false },
                activeToolbarItems: { [0]: { align: { $set: "" } }, [1]: { deletable: { $set: false } } }
            })

            return update(state, {
                livefeedSlides: { [action.slideCurrentIndex]: { logoState: { $set: hideLogoPlaceholder } } }
            })
        }
        // Line
        case a.SET_LINE: {
            return update(state, {
                livefeedSlides: { [action.payload.slideCurrentIndex]: { lineState: { $set: action.payload } } }
            })
        }
        case a.REMOVE_LINE: {
            let hideLine = update(defaultEditorState.livefeedSlides[0].lineState, {
                show: { $set: false },
                activeToolbarItems: { [0]: { align: { $set: "" } }, [1]: { deletable: { $set: false } } }
            })
            return update(state, {
                livefeedSlides: { [action.slideCurrentIndex]: { lineState: { $set: hideLine } } }
            })
        }
        // Text
        case a.ADD_TEXT: {
            return update(state, {
                livefeedSlides: { [action.payload.slideCurrentIndex]: { textContainer: { $push: [action.payload] } } }
            })
        }
        case a.REMOVE_TEXT: {
            return update(state, {
                livefeedSlides: { [action.payload.slideCurrentIndex]: { textContainer: { $splice: [[action.payload.id, 1]] } } }// payload is an index number
            })
        }
        case a.SET_TEXT: {
            return update(state, {
                livefeedSlides: { [action.payload.slideCurrentIndex]: { textContainer: { [action.payload.id]: { $set: action.payload } } } }// payload is an index number
            })
        }
        // Set Background color
        case a.SET_SLIDE_BG: {
            return update(state, {
                livefeedSlides: { [action.payload.slideCurrentIndex]: { slideBg: { $set: action.payload } } }
            })
        }
        case a.SET_LEFT_PANEL_BG: {
            return update(state, {
                livefeedSlides: { [action.payload.slideCurrentIndex]: { leftPanelBg: { $set: action.payload } } }
            })
        }
        case a.SET_RIGHT_PANEL_BG: {
            return update(state, {
                livefeedSlides: { [action.payload.slideCurrentIndex]: { rightPanelBg: { $set: action.payload } } }
            })
        }
        // gauge
        case a.SET_GAUGE: {
            return update(state, {
                livefeedSlides: { [action.payload.slideCurrentIndex]: { [action.payload.id]: { $set: action.payload } } }
            })
        }
        // Locations List Style
        case a.SET_LOCATIONS_LIST_STYLE: {
            return update(state, {
                livefeedSlides: { [action.payload.slideCurrentIndex]: { locationsListStyle: { $set: action.payload } } }
            })
        }
        //Right Panel Text title
        case a.SET_GAUGE_TITLE: {
            return update(state, {
                livefeedSlides: { [action.payload.slideCurrentIndex]: { rightPanelTextTitle: { $set: action.payload } } }
            })
        }
        //Right Panel Gauge Value Label
        case a.SET_GAUGE_LABEL: {
            return update(state, {
                livefeedSlides: { [action.payload.slideCurrentIndex]: { rightPanelGaugeValueLabel: { $set: action.payload } } }
            })
        }
        //Right Panel Gauge Occupied Background color
        case a.SET_GAUGE_OCCUPIED_BG: {
            return update(state, {
                livefeedSlides: { [action.payload.slideCurrentIndex]: { rightPanelGaugeOccupiedBg: { $set: action.payload } } }
            })
        }
        //Right Panel Gauge Offset Background color
        case a.SET_GAUGE_OFFSET_BG: {
            return update(state, {
                livefeedSlides: { [action.payload.slideCurrentIndex]: { rightPanelGaugeOffsetdBg: { $set: action.payload } } }
            })
        }
        //Right Panel Gauge Needle Background color
        case a.SET_GAUGE_NEEDLE_BG: {
            return update(state, {
                livefeedSlides: { [action.payload.slideCurrentIndex]: { rightPanelGaugeNeedle: { $set: action.payload } } }
            })
        }
        default: {
            return state
        }
    }
}



// WEBPACK FOOTER //
// ./src/reducers/livefeededitor/editorReducer.js